import { Component, OnInit } from '@angular/core';
import { IktatgatoService } from '../iktatgato.service';
import { DataService } from '../../data.service';

/**
 *  TÖMEGES KIKÜLDÉS – kötegek.
 *
 *  Öt lépés, mert mindegyiknél el lehet akadni, és külön kell látni, hol:
 *  összeállítás → dokumentum → aláírás → iktatás → kiküldés. Minden lépés
 *  újrafuttatható; ami kész, azt kihagyja, ami hibára futott, azt újrapróbálja.
 *
 *  A bérjegyzék DOKUMENTUMÁT nem itt gyártjuk: a Riportok képernyő tölti fel
 *  dolgozónként, hogy a bérszámítás egyetlen helyen éljen.
 */
@Component({
  selector: 'app-ikt-kuldes',
  templateUrl: './kuldes.component.html',
  styleUrls: ['../iktatgato-layout/iktatgato-layout.component.scss'],
})
export class IktKuldesComponent implements OnInit {
  nezet: 'kotegek' | 'uj' = 'kotegek';

  kotegek: any[] = [];
  forrasok: any[] = [];
  konyvek: any[] = [];
  terv: any[] = [];
  ugyintezok: any[] = [];
  betoltes = false;

  ma = new Date();
  uj: any = {
    forras: 'riport', nev: '', konyv: '', iktatas_nelkul: false, tetelszam: '', ugyintezo: '',
    csatorna: 'bksz', ev: 0, ho: 0, tetelek: [] as string[],
  };
  tetelek: any[] = [];
  kijelolt = new Set<string>();

  megnyitott: any = null;
  lepesFut = '';

  readonly CSATORNAK = [
    { kulcs: 'bksz', nev: 'BKSZ (hivatali kapu / cégkapu / tárhely)' },
    { kulcs: 'email', nev: 'E-mail' },
    { kulcs: 'papir', nev: 'Papír (postakönyvbe)' },
  ];

  constructor(private ikt: IktatgatoService, private data: DataService) {}

  async ngOnInit() {
    this.uj.ev = this.ma.getFullYear();
    this.uj.ho = this.ma.getMonth() + 1;
    this.uj.ugyintezo = await this.ikt.ki();
    await this.betolt();
    try {
      this.konyvek = (await this.ikt.konyvek()).filter((k: any) => k.allapot === 'nyitva');
      if (this.konyvek.length) this.uj.konyv = this.konyvek[0].id;
      this.terv = await this.ikt.terv();
      this.ugyintezok = await this.ikt.ugyintezok();
    } catch { /* a lista enélkül is látszik */ }
  }

  async betolt() {
    this.betoltes = true;
    try {
      this.kotegek = await this.ikt.kotegek();
      this.forrasok = await this.ikt.kuldesForrasok(this.uj.ev, this.uj.ho);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A kötegek nem tölthetők be.', 'error');
    } finally { this.betoltes = false; }
  }

  /* ── Egyedi kiküldés: címzett-kereső ─────────────────────────────────────
   *
   *  A másik két forrás előre kiszámolt listából dolgozik; egy határozatot viszont egy
   *  embernek kell kiküldeni, akit a kolléga a NEVÉN keres. A találat hozza az e-mail
   *  címet is – de küldeni attól még kézzel küldünk. */
  get egyediMod(): boolean { return this.uj.forras === 'egyedi'; }

  /* ── ZIP-es kiküldés ──────────────────────────────────────────────────────
   *  A bérjegyzéket a bérprogram állítja elő, dolgozónként egy PDF-be. Ezeket egy
   *  ZIP-ben töltjük fel, és a rendszer a fájlnevekben lévő név alapján osztja szét.
   *  Ami nem egyértelmű, az kimarad – és tételesen megmondjuk, melyik és miért. */
  get zipMod(): boolean { return this.uj.forras === 'zip'; }

  zipFajl: File | null = null;
  zipFut = false;
  zipEredmeny: any = null;

  zipValaszt(esemeny: any) {
    this.zipFajl = esemeny?.target?.files?.[0] || null;
    this.zipEredmeny = null;
    if (esemeny?.target) esemeny.target.value = '';
  }

  async zipFeltoltes() {
    if (!this.zipFajl) { this.data.sendToast('Válassz ki egy ZIP fájlt.', 'warning'); return; }
    if (!this.uj.konyv && !this.uj.iktatas_nelkul) {
      this.data.sendToast('Válassz iktatókönyvet – vagy jelöld be, hogy iktatás nélkül megy.', 'warning');
      return;
    }
    this.zipFut = true;
    this.zipEredmeny = null;
    try {
      const r = await this.ikt.kotegZipbol(this.zipFajl, {
        nev: this.uj.nev, konyv: this.uj.konyv, iktatas_nelkul: this.uj.iktatas_nelkul,
        csatorna: this.uj.csatorna, tetelszam: this.uj.tetelszam, ugyintezo: this.uj.ugyintezo,
        ev: this.uj.ev, ho: this.uj.ho,
        //  Üresen is elküldjük: a kiszolgáló ebből tudja, hogy már megválaszoltuk a kérdést.
        partner_dontesek: JSON.stringify(this.partnerDontesek || {}),
      });
      this.zipEredmeny = r;
      this.partnerKerdesek = [];
      this.partnerDontesek = {};
      //  A ZIP-et MEGTARTJUK a kérdésig: ha kihez-kössük kérdés jön, újra fel kell küldeni.
      this.zipFajl = null;
      this.data.sendToast(`${r.db} dokumentum a kötegben.`
        + (r.kihagyva?.length ? ` ${r.kihagyva.length} fájl kimaradt.` : ''), 'success');
      await this.betolt();
    } catch (e: any) {
      //  A kiszolgáló a kimaradt fájlokat hibánál is tételesen megmondja – mutassuk meg.
      this.zipEredmeny = e?.error?.kihagyva ? e.error : null;
      /*  „Kihez kössük?" – nem hiba, hanem kérdés. A ZIP a böngészőben marad, hogy a
       *  válasz után ugyanazzal a gombbal újra fel lehessen küldeni. */
      if (e?.error?.partner_dontes?.length) {
        this.partnerKerdesTolt(e.error.partner_dontes);
        this.data.sendToast('Néhány címzett nincs a partnertörzsben – válaszd ki, kihez kössük, '
          + 'majd nyomd meg újra a feltöltést.', 'warning');
        return;
      }
      this.data.sendToast(e?.error?.error || 'A ZIP feldolgozása nem sikerült.', 'error');
    } finally {
      this.zipFut = false;
    }
  }

  szemelyKereses = '';
  szemelyTalalatok: any[] = [];
  szemelyFut = false;
  valasztottak: any[] = [];
  private szemelyIdozito: any = null;

  readonly KOR_NEV: any = {
    dolgozo: 'Munkatárs', tanulo: 'Tanuló', gondviselo: 'Gondviselő', partner: 'Partner',
  };

  szemelyKeres() {
    clearTimeout(this.szemelyIdozito);
    this.szemelyIdozito = setTimeout(async () => {
      const sz = this.szemelyKereses.trim();
      if (sz.length < 2) { this.szemelyTalalatok = []; return; }
      this.szemelyFut = true;
      try {
        const r = await this.ikt.kuldesSzemelyek(sz);
        const bent = new Set(this.valasztottak.map((x) => `${x.tipus}:${x.azonosito}`));
        this.szemelyTalalatok = (r.talalatok || []).filter((x: any) => !bent.has(`${x.tipus}:${x.azonosito}`));
      } catch (e) { this.szemelyTalalatok = []; } finally { this.szemelyFut = false; }
    }, 300);
  }

  szemelyHozzaad(x: any) {
    this.valasztottak = [...this.valasztottak, { ...x }];
    this.szemelyTalalatok = this.szemelyTalalatok.filter((t) => t !== x);
    this.szemelyKereses = '';
  }

  szemelyKivesz(x: any) {
    this.valasztottak = this.valasztottak.filter((t) => t !== x);
  }

  /** Hány címzettnek nincs e-mail címe – e-mail csatornánál ez akadály. */
  get emailHianyzik(): number {
    return this.valasztottak.filter((x) => !String(x.email || '').trim()).length;
  }

  async tetelekBetolt() {
    try {
      const r = await this.ikt.kuldesTetelek(this.uj.forras, this.uj.ev, this.uj.ho);
      this.tetelek = r.tetelek || [];
      this.kijelolt.clear();
    } catch (e: any) {
      this.tetelek = [];
      this.data.sendToast(e?.error?.error || 'A tételek nem tölthetők be.', 'error');
    }
  }

  valt(t: any, be: boolean) {
    if (t.akadaly || t.mar_kikuldve) return;
    if (be) this.kijelolt.add(t.forras_azonosito); else this.kijelolt.delete(t.forras_azonosito);
  }
  kivan(t: any) { return this.kijelolt.has(t.forras_azonosito); }
  mindet() {
    for (const t of this.tetelek) if (!t.akadaly && !t.mar_kikuldve) this.kijelolt.add(t.forras_azonosito);
  }

  /** Kézbesíthetőségi figyelmeztetés: BKSZ-en csak teljes azonosítóval megy ki. */
  kapuGond(t: any) {
    return this.uj.csatorna === 'bksz' && t.kapu_hiany?.length ? t.kapu_hiany.join(', ') : '';
  }

  async kotegLetrehoz() {
    if (this.egyediMod) {
      if (!this.valasztottak.length) { this.data.sendToast('Válassz címzettet.', 'warning'); return; }
      if (!String(this.uj.nev || '').trim()) {
        this.data.sendToast('Add meg a tárgyat – ez lesz az irat tárgya az iktatásnál.', 'warning');
        return;
      }
    } else if (!this.kijelolt.size) {
      this.data.sendToast('Jelölj ki legalább egy címzettet.', 'warning'); return;
    }
    /*  IKTATÁS NÉLKÜL IS MEHET – de szándékosan kell kérni.
     *  A bérjegyzék jellemzően nem iktatandó irat; az iktatókönyv megkövetelése miatt
     *  eddig egy „gyűjtő" könyvet kellett nyitni hozzá, amitől a postakönyv tele lett
     *  olyan iratszámokkal, amiket senki nem akart. Az ÜRES mező viszont továbbra is
     *  hiba: egy elfelejtett választásból ne legyen néma iktatás-kihagyás. */
    if (!this.uj.konyv && !this.uj.iktatas_nelkul) {
      this.data.sendToast('Válassz iktatókönyvet – vagy jelöld be, hogy iktatás nélkül megy.', 'warning');
      return;
    }
    try {
      const r = await this.ikt.kotegLetrehoz(this.egyediMod
        ? { ...this.uj, cimzettek: this.valasztottak, partner_dontesek: this.partnerDontesek }
        : { ...this.uj, tetelek: Array.from(this.kijelolt), partner_dontesek: this.partnerDontesek });
      this.partnerKerdesek = [];
      this.partnerDontesek = {};
      this.data.sendToast(`Köteg létrehozva: ${r.db} tétel.`
        + (r.kihagyva?.length ? ` ${r.kihagyva.length} kimaradt.` : ''), 'success');
      this.nezet = 'kotegek';
      await this.betolt();
      await this.megnyit({ id: r.id });
    } catch (e: any) {
      //  „Kihez kössük?" – nem hiba, hanem kérdés: a válasz után ugyanez a gomb megy tovább.
      if (e?.error?.partner_dontes?.length) { this.partnerKerdesTolt(e.error.partner_dontes); return; }
      this.data.sendToast(e?.error?.error || 'A köteg létrehozása nem sikerült.', 'error');
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
   *  KIHEZ KÖSSÜK A CÍMZETTET?
   *
   *  A tömeges feladás korábban MINDEN címzetthez új partnert hozott létre, mert a
   *  keresés nem talált rá a meglévőre (más `forras`-névvel volt elmentve). A
   *  duplikátumon nem volt kapcsolati kód – így a kézzel beírt kód „eltűnt", és a
   *  hivatali kapus kiküldés elakadt. Most a rendszer köt, ha talál, és KÉRDEZ, ha
   *  újat kellene létrehoznia.
   * ═════════════════════════════════════════════════════════════════════ */
  partnerKerdesek: any[] = [];
  partnerDontesek: any = {};

  private partnerKerdesTolt(lista: any[]) {
    this.partnerKerdesek = lista;
    //  Ha van javaslat, az elsőt kínáljuk fel – de a választás a felhasználóé marad.
    for (const k of lista) {
      if (!this.partnerDontesek[k.kulcs]) {
        this.partnerDontesek[k.kulcs] = k.javaslatok?.length
          ? { partner_id: k.javaslatok[0].id } : { uj: true };
      }
    }
  }

  partnerValasztas(k: any, ertek: string) {
    this.partnerDontesek[k.kulcs] = ertek === '__uj' ? { uj: true } : { partner_id: ertek };
  }

  partnerValasztott(k: any): string {
    const d = this.partnerDontesek[k.kulcs];
    return d?.uj ? '__uj' : (d?.partner_id || '');
  }

  partnerKerdesMegse() { this.partnerKerdesek = []; this.partnerDontesek = {}; }

  async megnyit(k: any) {
    try { this.megnyitott = await this.ikt.koteg(k.id); }
    catch (e: any) { this.data.sendToast(e?.error?.error || 'A köteg nem tölthető be.', 'error'); }
  }

  async lepes(nev: 'alairas' | 'iktatas' | 'kuldes') {
    if (!this.megnyitott) return;
    this.lepesFut = nev;
    try {
      const r = await this.ikt.kotegLepes(this.megnyitott.koteg.id, nev);
      const cimke = { alairas: 'aláírva', iktatas: 'iktatva', kuldes: 'kiküldve' }[nev];
      this.data.sendToast(`${r.kesz} tétel ${cimke}.`
        + (r.hibak?.length ? ` ${r.hibak.length} hibára futott.` : ''),
        r.hibak?.length ? 'warning' : 'success');
      await this.megnyit(this.megnyitott.koteg);
      await this.betolt();
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A lépés nem futott le.', 'error');
    } finally { this.lepesFut = ''; }
  }

  /*  DOKUMENTUM FELTÖLTÉSE EGY TÉTELHEZ.
   *
   *  A bérjegyzéknél a Riportok képernyő, a ZIP-esnél a kicsomagolás tölti fel a PDF-et.
   *  Az EGYEDI kiküldésnél viszont senki – ott a felhasználónak kell, és eddig nem volt
   *  hol: a köteg megnyílt, de a „2. Dokumentum" lépés sehol nem jelent meg, így a
   *  tétel dokumentum nélkül állt meg az aláírásnál.
   *
   *  Aláírt tételre nem tölthető fel: az aláírás arra a PDF-re szól, ami kimegy. */
  tetelFeltoltFut = '';

  async tetelFajl(t: any, esemeny: any) {
    const f = esemeny?.target?.files?.[0] || null;
    if (esemeny?.target) esemeny.target.value = '';
    if (!f || !this.megnyitott) return;
    if (f.size > 25 * 1024 * 1024) {
      this.data.sendToast('A fájl túl nagy (legfeljebb 25 MB).', 'warning');
      return;
    }
    this.tetelFeltoltFut = t.id;
    try {
      await this.ikt.kotegTetelDokumentum(this.megnyitott.koteg.id, t.id, f);
      this.data.sendToast(`Feltöltve: ${t.cimzett_nev}.`, 'success');
      await this.megnyit(this.megnyitott.koteg);
    } catch (e: any) {
      this.data.sendToast(e?.error?.error || 'A feltöltés nem sikerült.', 'error');
    } finally { this.tetelFeltoltFut = ''; }
  }

  letoltes(t: any) { this.data.megnyitFajl(this.ikt.kotegTetelUrl(t.id), t?.cimzett_nev || 'Dokumentum'); }

  tetelSzin(t: any) {
    // a meghiúsulási / visszahívási igazolás a BKSZ-letöltésből jön
    if (t.statusz === 'hiba' || t.statusz === 'meghiusult' || t.statusz === 'visszahivva') return 'danger';
    if (t.statusz === 'elkuldve' || t.statusz === 'atveve') return 'success';
    if (t.statusz === 'alairva') return 'tertiary';
    return 'medium';
  }
}
